import { UrlType } from '@hydra/utils/getTranslatedUrl';

export interface Item {
  label: string
  link?: UrlType
  gtmLabel?: string
  header?: boolean
  chipTag?: string
  externalLink?: string
}

export interface MenuItem {
  label: string
  group?: boolean
  link?: UrlType
  items?: Item[][]
}

const menuItems: MenuItem[] = [
  {
    label: 'pages_productsandfeatures_header',
    group: true,
    items: [
      [
        {
          label: 'pages_productsandfeatures_products_header',
          header: true
        },
        {
          label: 'pages_productsandfeatures_products_overview_header',
          link: 'marketing-tools'
        },
        {
          label: 'pages_productsandfeatures_products_reviews_header',
          link: 'website-reviews'
        },
        {
          label: 'pages_productsandfeatures_products_keyword_header',
          link: 'keyword-tool'
        },
        {
          label: 'pages_productsandfeatures_products_competitors_header',
          link: 'competitors'
        },
        {
          label: 'pages_productsandfeatures_products_sitecrawl_header',
          link: 'site-crawl'
        }
      ],
      [
        {
          label: 'pages_productsandfeatures_sales_header',
          header: true
        },
        {
          label: 'pages_productsandfeatures_sales_overview_header',
          link: 'sales-tools'
        },
        {
          label: 'pages_productsandfeatures_sales_whitelabelreport_header',
          link: 'white-label-reports'
        },
        {
          label: 'pages_productsandfeatures_sales_leadgen_header',
          link: 'leadgen-tool'
        }
      ],
      [
        {
          label: 'pages_productsandfeatures_tools_alt_header',
          header: true
        },
        {
          label: 'pages_productsandfeatures_tools_assistant_header',
          link: 'assistant',
          chipTag: 'pages_resources_label'
        },
        {
          label: 'pages_productsandfeatures_tools_extension_header',
          link: 'extension'
        },
        {
          label: 'pages_productsandfeatures_tools_api_header',
          link: 'api'
        },
        {
          label: 'pages_productsandfeatures_tools_bulk_header',
          link: 'bulk-reports'
        },
        {
          label: 'pages_productsandfeatures_tools_index_header',
          externalLink: 'https://index.woorank.com/'
        }
      ]
    ]
  },
  {
    label: 'pages_solutions_header',
    group: true,
    items: [
      [
        {
          label: 'pages_solutions_sales_teams',
          link: 'sales-teams'
        },
        {
          label: 'pages_solutions_marketing_teams',
          link: 'marketing-teams'
        },
        {
          label: 'pages_solutions_small_businesses',
          link: 'small-businesses'
        },
        {
          label: 'pages_solutions_data_services',
          link: 'data-services'
        },
        {
          label: 'pages_solutions_seo_agencies',
          link: 'seo-agencies'
        },
        {
          label: 'pages_solutions_developers',
          link: 'developers'
        }
      ]
    ]
  },
  {
    label: 'pages_enterprise_header',
    link: 'enterprise'
  },
  {
    label: 'pricing',
    link: 'pricing'
  },
  {
    label: 'pages_resources_header',
    group: true,
    items: [
      [
        {
          label: 'core_web_vitals',
          link: 'core-web-vitals',
          chipTag: 'pages_resources_label'
        },
        {
          label: 'pages_resources_blog',
          link: 'blog'
        },
        {
          label: 'pages_resources_seoguides',
          link: 'seo-guides'
        },
        {
          label: 'pages_resources_customerstories',
          link: 'customer-stories'
        }
      ]
    ]
  }
];

export default menuItems;
